import React from 'react';
import SEO from '../components/SEO';

const About = () => {
  return (
    <>
      <SEO
        title="About Us"
        description="Meet Ashley, the voice and face behind Broadway Muses, and learn how her background in studio art shapes her writing about Broadway."
        path="/about"
      />

      <section
        aria-labelledby="about-page-title"
        className="mx-auto w-full max-w-5xl px-6 pb-32 pt-40"
      >
        <header className="mb-16 border-b-8 border-black pb-8 text-center">
          <p className="mb-6 font-mono text-xs font-black uppercase tracking-[0.3em]">
            Broadway Muses
          </p>
          <h1
            id="about-page-title"
            className="break-words font-serif text-[clamp(3rem,10vw,7rem)] font-black uppercase italic leading-none"
          >
            About Us
          </h1>
        </header>

        <div className="grid items-start gap-12 lg:grid-cols-[minmax(0,1fr)_minmax(240px,0.55fr)]">
          <article
            aria-label="About Ashley and Broadway Muses"
            className="max-w-3xl border-l-4 border-black pl-6 sm:pl-10"
          >
            <p className="font-serif text-2xl font-bold leading-tight sm:text-4xl">
              Hi, I’m Ashley, a 23-year-old theater lover and the voice and face
              behind Broadway Muses.
            </p>
            <p className="mt-8 font-mono text-sm leading-loose text-black/75">
              I majored in drawing and hold a BFA in studio art, but my heart
              has always split between the canvas and the stage. Growing up, I
              dreamed of being an actress, and that same love of storytelling
              and character now shapes how I write about Broadway — with an
              artist’s eye for detail and a fan’s genuine excitement for the
              shows I cover.
            </p>
          </article>

          <figure className="w-full max-w-sm border-2 border-black bg-white p-3 lg:justify-self-end">
            <img
              src="https://res.cloudinary.com/dwumujtpu/image/upload/v1787194787/IMG_1088_p05yyy.jpg"
              alt="Ashley, the voice behind Broadway Muses"
              className="h-auto w-full object-cover"
            />
            <figcaption className="pt-3 font-mono text-[10px] font-black uppercase leading-relaxed tracking-[0.2em]">
              Ashley / Broadway Muses
            </figcaption>
          </figure>
        </div>
      </section>
    </>
  );
};

export default About;